<div>
    <swiper class="swiper-container swiper-pad" [config]="carouselConfig">
        <div *ngFor="let slide of slides" class="swiper-slide">
            <carousel-slide [modules]="slide" [showProgress]="showProgress"></carousel-slide>
        </div>
    </swiper>
</div>